/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DocumentStatusResponse interface.
 */
export function instanceOfDocumentStatusResponse(value) {
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function DocumentStatusResponseFromJSON(json) {
    return DocumentStatusResponseFromJSONTyped(json, false);
}
export function DocumentStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'documentId': json['documentId'],
        'status': json['status'],
        'jobStatus': json['jobStatus'] == null ? undefined : json['jobStatus'],
        'jobError': json['jobError'] == null ? undefined : json['jobError'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'processingError': json['processingError'] == null ? undefined : json['processingError'],
    };
}
export function DocumentStatusResponseToJSON(json) {
    return DocumentStatusResponseToJSONTyped(json, false);
}
export function DocumentStatusResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'documentId': value['documentId'],
        'status': value['status'],
        'jobStatus': value['jobStatus'],
        'jobError': value['jobError'],
        'jobId': value['jobId'],
        'processingError': value['processingError'],
    };
}
